const FormResources = {

    form_data:{
        rotation_setup_id: '',
        associate_id: '',
        rotation_day_id: '',
        supervisor_id: '',
        assignment_id: '',
        rotation_days: [],
        new_associates: [],
        date: [],
        all_dates: false,
    },

    form_format:[
        {
            css_class:  'col-md-12',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   true,
        },
    ],

    form_format_assignment:[
        {
            css_class:  'col-md-12',
            type:       'vue-multiselect',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
            multiple:   false
        },
    ],

    form_format_associate:[
        {
            css_class:  'col-md-12 div__multiselect',
            type:       'vue-multiselect',
            id:         'multiselect__schedule',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            multiple:   false
        },
    ],

    rotation_data:{
        rotation_setup_id:   '',
    },

    rotation_form_format:[
        {
            css_class:  'col-md-12',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Rotation setup:',
            model_name: 'rotation_setup_id',
            ref:        'rotation_setup_id_input',
            ref_alt:    'rotation_setup_id_input_alt',
            required:   false,
        },
    ],

    schedule_options:[
        {
            id:     1,
            name:   'Monday',
        },
        {
            id:     2,
            name:   'Tuesday',
        },
        {
            id:     3,
            name:   'Wednesday',
        },
        {
            id:     4,
            name:   'Thursday',
        },
        {
            id:     5,
            name:   'Friday',
        },
        {
            id:     6,
            name:   'Saturday',
        },
        {
            id:     7,
            name:   'Sunday',
        },
    ],

}

export default FormResources;